import axios from 'axios';

const instance = axios.create({
  baseURL: '/',
});

instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
instance.defaults.headers.get.Accept = 'application/json';
instance.defaults.headers.token = 'web';
instance.defaults.headers.isocode = 'uk';
instance.defaults.headers.user = 'test@test.com';
instance.defaults.headers.post['Content-Security-Policy'] = "default-src 'self'; frame-ancestors 'self'";
instance.defaults.headers.get['Content-Security-Policy'] = "default-src 'self'; frame-ancestors 'self'";
instance.defaults.headers.post['X-Content-Type-Options'] = "nosniff";
instance.defaults.headers.get['X-Content-Type-Options'] = "nosniff";

export default instance;